/**
 * スライド生成
 */

import * as THREE from 'three';

import {
	SLIDES,
	IMAGE_COUNT,
	CONFIG,
} from './config.js';

/**
* スライド用Geometry生成
* 円弧状のパネルを作成する
*/
export const createSlideGeometry = () => {
	const isPc = window.innerWidth >= CONFIG.breakpoint;
	// 何度分の円弧を切り出すか
	let arcWidth;
	let thetaLength;
	if (isPc) {
		arcWidth = CONFIG.slideHeightPc[IMAGE_COUNT] * (CONFIG.aspectPc);
		thetaLength = arcWidth / CONFIG.arcFactorPc;
	} else {
		arcWidth = CONFIG.slideHeightSp * (CONFIG.aspectSp);
		thetaLength = arcWidth / CONFIG.arcFactorSp;
	}
	return new THREE.CylinderGeometry(
		// 上面半径
		isPc ? CONFIG.radiusTopPc : CONFIG.radiusTopSp,
		// 下面半径
		isPc ? CONFIG.radiusBottomPc : CONFIG.radiusBottomSp,
		// 高さ
		isPc ? CONFIG.slideHeightPc[IMAGE_COUNT] : CONFIG.slideHeightSp,
		// 分割数（増やすほど滑らかな円柱になる）
		32,
		// 高さ方向の分割数
		1,
		// 上底と下底の蓋を開放するかどうか（true:蓋をしない）
		true,
		// 描画を開始する角度
		-thetaLength / 2,
		// 描画する角度の範囲
		thetaLength
	);
};
const slideGeometry = createSlideGeometry();

/**
* 画像をトリミング（object-fit:cover;みたいにする）
*/
const fitTextureCover = (
	texture,
) => {
	const isPc = window.innerWidth >= CONFIG.breakpoint;
	const imgAspect =
		texture.image.width /
		texture.image.height;
	texture.center.set(
		0.5,
		0.5
	);
	const targetAspect = isPc ? CONFIG.aspectPc : CONFIG.aspectSp;
	if (imgAspect > targetAspect) {
		// 横長画像
		texture.repeat.x = targetAspect / imgAspect;
		texture.repeat.y = 1;
	} else {
		// 縦長画像
		texture.repeat.x = 1;
		texture.repeat.y = imgAspect / targetAspect;
	}
	texture.needsUpdate = true;
};

/**
 * スライド生成
 * @param {*} param0
 */
export const createSlides = ({
	rotateGroup,
	textureLoader,
}) => {

	SLIDES.forEach((slide, index) => {
		const texture =
			textureLoader.load(
				slide.img,
				texture => {
					texture.colorSpace = THREE.SRGBColorSpace;
					fitTextureCover(texture);
				}
			);
		// スライド用Material生成const renderer
		const material =
			new THREE.MeshBasicMaterial({
				map: texture,
				side: THREE.DoubleSide,
				transparent: true
			});
		// -------------------------
		// Mesh
		// -------------------------
		const mesh =
			new THREE.Mesh(
				slideGeometry,
				material
			);
		// -------------------------
		// スライド情報
		// -------------------------
		// 生成したメッシュにスライド番号(index)、URL、title、date、stateを追加
		mesh.userData = {
			index,
			url: slide.url,
			title: slide.title,
			date: slide.date,
			state: 'other'
		};
		// -------------------------
		// 円周上へ配置
		// -------------------------
		setSlidePosition({ mesh, index });
		rotateGroup.add(mesh);
	});
};
// スライドの初期配置
export const setSlidePosition = ({
	mesh,
	index
}) => {
	const isPc = window.innerWidth >= CONFIG.breakpoint;
	// -------------------------
	// 初期表示時に1枚目を正面に見せるため
	// 指定枚数分だけ回転位置をずらす
	// -------------------------
	const fullAngle = Math.PI * 2; // 円一周の角度
	// 何枚分の回転位置をずらすか指定
	const shiftNum = CONFIG.slideShift[IMAGE_COUNT];
	const angle =
		(index / IMAGE_COUNT) *
		fullAngle +
		(fullAngle / IMAGE_COUNT) * shiftNum;
	// スライド配置
	mesh.position.x =
		Math.sin(angle) *
		(isPc ? CONFIG.radiusPc[IMAGE_COUNT] : CONFIG.radiusSp[IMAGE_COUNT]);
	mesh.position.z =
		Math.cos(angle) *
		(isPc ? CONFIG.radiusPc[IMAGE_COUNT] : CONFIG.radiusSp[IMAGE_COUNT]);
	// 常に中心を向く
	mesh.rotation.y = angle + Math.PI;
	// 初期状態
	mesh.scale.set(
		1,
		1,
		1
	);
}
